interface FileCheckIconProps {
  className?: string
}

export const FileCheckIcon = ({ className }: FileCheckIconProps) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect y="0.5" width="16" height="16" rx="8" fill="#2E7D32" />
      <path
        d="M5 8.23333L7.17021 10.5L11 6.5"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
